import { Shapes } from '@/components/public/Visualisations/types'
import { YAxisProps } from '@/components/public/Visualisations/XYBubbles/types'
import { Coordinate2D, Path } from '@/types'
import Konva from 'konva'

const LINE_WIDTH = 4

export class YAxisLine extends Konva.Line implements Shapes.Shape {
  key: string = 'axis-line'
  path: Path = new Path({})
  center: Coordinate2D = this.position()
  capabilities: Shapes.Capability[] = []
  refresh: () => void = () => {}
  length: number = 0

  constructor() {
    super({
      stroke: '#6C757D',
      strokeWidth: LINE_WIDTH,
      offsetY: -(LINE_WIDTH / 2),
      listening: false,
    })
  }

  update(props: YAxisProps) {
    this.points([props.startPoint.x, props.startPoint.y, props.endPoint.x, props.endPoint.y])

    this.length = props.endPoint.y - props.startPoint.y

    this.offsetX(props.xOffset)
    this.moveToTop()
  }
}
